// Static content for the DubbleUpp landing page

export const IMAGES = {
  heroMain:
    "https://static.prod-images.emergentagent.com/jobs/c243c093-0141-4044-bb5c-a9508cadcff7/images/994cffb9215db5eeb4a8ef429ece0c7c45e1fa9e2681f2ab49d5843db1c7fa80.jpeg",
  roommates:
    "https://static.prod-images.emergentagent.com/jobs/c243c093-0141-4044-bb5c-a9508cadcff7/images/9415dea582958d70bcb1dd2944468f6500290112b6cfae45877ccc61108767c4.jpeg",
  agreement:
    "https://static.prod-images.emergentagent.com/jobs/c243c093-0141-4044-bb5c-a9508cadcff7/images/cbc8de156a34a01b62f9aad1195666325df8cfcfc0122619137fc77159c84a53.jpeg",
  investor:
    "https://static.prod-images.emergentagent.com/jobs/c243c093-0141-4044-bb5c-a9508cadcff7/images/8520ddc5def0fe421fe5382d75f6c51d829bdf9e971b013de24b0754fd5654b1.jpeg",
  team: "https://customer-assets-jt897jd0.emergentagent.net/job_d337669f-3cf4-4ab7-90e9-46eb65b8cc9b/artifacts/gkzgiayh_730d746a-355d-4eb0-8bbe-6c9413e01fd6.png",
};

export const coBuyerTypes = ["Friend", "Sibling", "Family Member", "Roommate", "Partner"];

export const agreementTopics = [
  "Ownership",
  "Down Payment",
  "Mortgage Payments",
  "Repairs",
  "Expenses",
  "Selling",
  "Refinancing",
  "Exit Terms",
];

export const whoCanDubbleUpp = [
  { label: "Friends", icon: "Users" },
  { label: "Family", icon: "Heart" },
  { label: "Partners", icon: "HeartHandshake" },
  { label: "Co-workers", icon: "Briefcase" },
  { label: "Roommates", icon: "DoorOpen" },
  { label: "You Decide", icon: "Sparkles" },
];

export const howItWorks = [
  {
    step: "01",
    title: "Sign Up as a Buyer or Investor",
    text: "Sign up and create your profile as a Buyer or Investor — it's totally free. After that, you're ready to start making moves.",
    icon: "UserPlus",
  },
  {
    step: "02",
    title: "Find the Right Person for You",
    text: "Learn everything you need to know to buy using DubbleUpp, guided by our expert Real Estate Agents and Mortgage Professionals.",
    icon: "Handshake",
  },
  {
    step: "03",
    title: "Finally, DubbleUpp to Buy",
    text: "Now it's time to find your new home and buy it, together. It's really that easy. Nice move!",
    icon: "KeyRound",
  },
];

export const investorTypes = [
  { label: "Parents & Grandparents", icon: "Heart" },
  { label: "Family & Friends", icon: "HeartHandshake" },
  { label: "Real Estate Investors", icon: "TrendingUp" },
  { label: "Business Owners", icon: "Briefcase" },
  { label: "Employers", icon: "Building2" },
  { label: "Anyone Growing Their Money", icon: "PiggyBank" },
];

export const investorSteps = [
  {
    num: "01",
    title: "The investor contributes.",
    text: "A parent puts 5% toward the down payment on their adult child's first home. Any investor could do the same for any buyer.",
  },
  {
    num: "02",
    title: "The buyer lives in it and pays for it.",
    text: "The buyer moves in, makes the mortgage payments, and can even bring in roommates to help cover housing costs.",
  },
  {
    num: "03",
    title: "Everyone shares the upside.",
    text: "After an agreed period — say six years — the home is sold or refinanced and the value created is split according to the DubbleUpp Agreement.",
  },
];

export const journeyOptions = [
  { id: "buy", label: "I'd like to buy a home" },
  { id: "own-buy-another", label: "I already own and may buy another" },
  { id: "investor", label: "I'm interested in becoming an investor" },
  { id: "exploring", label: "I'm just exploring what's possible" },
];

export const pathOptions = [
  {
    id: "buyer-buyer",
    label: "Buyer + Buyer",
    desc: "Combine buying power with someone I know and own a home together.",
  },
  {
    id: "buyer-investor",
    label: "Buyer + Investor",
    desc: "One person lives in and pays for the home while another helps fund the purchase.",
  },
  {
    id: "not-sure",
    label: "Not sure yet",
    desc: "I'd like the DubbleUpp team to walk me through my options.",
  },
];

export const timelineOptions = [
  { id: "asap", label: "As soon as I find the right home" },
  { id: "2-3mo", label: "Within 2–3 months" },
  { id: "3-6mo", label: "Within 3–6 months" },
  { id: "6mo+", label: "More than 6 months" },
  { id: "unsure", label: "I'm not sure yet" },
];

export const homeTypeOptions = ["Single-Family", "Townhouse", "Condo", "Multi-Family"];
export const bedroomOptions = ["1", "2", "3", "4", "5+"];
export const bathroomOptions = ["1", "1.5", "2", "2.5", "3+"];

export const livingOptions = [
  { id: "renting", label: "Renting" },
  { id: "own", label: "Own a home" },
  { id: "family", label: "Living with family" },
  { id: "other", label: "Other" },
];

export const US_STATES = [
  "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware",
  "District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas",
  "Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi",
  "Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York",
  "North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island",
  "South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington",
  "West Virginia","Wisconsin","Wyoming",
];

export const partnerOptions = [
  { id: "yes", label: "Yes, I already have someone in mind" },
  { id: "no", label: "No — help me find the right match" },
];
